import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { productPriceConverter } from '@/lib/converters/product/productPrice/productPriceConverter'
import { zProductsPriceResponse } from '@/schemas/productsPriceResponseSchema'

import type { ProductsPriceResponseDto as ResponseDto } from '@/gen/bff'
import type { ProductsPriceResponseSchema } from '@/schemas/productsPriceResponseSchema'

export const getPricesConverter = (data: ResponseDto): ProductsPriceResponseSchema => {
  const response: ProductsPriceResponseSchema = {
    siteId: data.siteId ?? '',
    productPrices: data.validPrices?.map(productPriceConverter) ?? [],
  }

  return zProductsPriceResponse.catch(defaultZodCatch).parse(response)
}
